import React from "react";

class SearchErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.handleRetry = this.handleRetry.bind(this);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Replace with your real logging/observability call
        // (Sentry, Datadog, etc.) — kept as console.error so this
        // still works out of the box with no extra setup.
        console.error("SearchBar crashed:", error, info);
        this.props.onError?.(error, info);
    }

    handleRetry() {
        this.setState({ hasError: false });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="search-pill-outer">
                    <div className="search-pill search-pill-fallback">
                        <span className="search-fallback-text">Search is temporarily unavailable.</span>
                        <button type="button" className="search-fallback-retry" onClick={this.handleRetry}>
                            Retry
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default SearchErrorBoundary;